import React, { Component } from "react";
import {
  List,
  Edit,
  Datagrid,
  TextField,
  ReferenceField,
  Button,
  ReferenceInput,
  EditButton,
  required,
  DateField,
  AutocompleteInput,
  SelectInput,
  Toolbar,
  SaveButton,
  SimpleForm,
  Filter,
  useRecordContext,
  DateInput,
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import Modal from "react-responsive-modal";
import myDataProvider from "../../src/myRestProvider";
import noImage from "./../images/combined-shape.svg";
import moment from "moment";
import { CREATE } from "ra-core";
import { getLocalStorageKey } from "../common/common";

// class PostPanel extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             open: false,
//         };
//     }

//     onOpenModal = () => {
//         console.log('open',this.props);
//         this.setState({ open: true})
//     };

//     onCloseModal = () => {
//         console.log(this.state.open);
//         this.setState({ open: false });
//     };
//     render(){
//         const { open } = this.state;
//         const {props} = this;
//         const fileData = JSON.parse(props.imageDetails);
//         const fileType = fileData.file_type;
//         let imagePath =this.props.imageDetails.split('.');
//         imagePath = imagePath[imagePath.length - 1];
//         return(
//         <div>
//             {
//             <div>
//                 <a className="list-img" >
//                 { fileType === 'image' ?
//                     <img onClick={this.onOpenModal} src={fileData.file_data} />:
//                     <img src={noImage} />
//                 }
//                 </a>
//                 <Modal open={open} onClose={this.onCloseModal}>
//                     <div className="image-large-view">
//                         { fileType === 'image' ?
//                             <img src= {fileData.file_data} />:
//                             <img src= {noImage} />
//                         }
//                     </div>
//                 </Modal>
//             </div>
//             }
//         </div>
//         )
//     }
// }

const PostPanel = (props) => {
  const [open, setOpen] = React.useState(false);

  const onOpenModal = () => {
    console.log("open", props);
    setOpen(true);
  };

  const onCloseModal = () => {
    console.log(open);
    setOpen(false);
  };

  const fileData = JSON.parse(props.imageDetails);
  const fileType = fileData.file_type;
  let imagePath = props.imageDetails.split(".");
  imagePath = imagePath[imagePath.length - 1];
  return (
    <div>
      {open ? (
        <div>
          <a className="list-img">
            {fileType === "image" ? (
              <img onClick={onOpenModal} src={fileData.file_data} />
            ) : (
              <img src={noImage} />
            )}
          </a>
          <Modal open={open} onClose={onCloseModal}>
            <div className="image-large-view">
              {fileType === "image" ? (
                <img src={fileData.file_data} />
              ) : (
                <img src={noImage} />
              )}
            </div>
          </Modal>
        </div>
      ) : (
        <a className="list-img">
          {fileType === "image" ? (
            <img onClick={onOpenModal} src={fileData.file_data} />
          ) : (
            <img src={noImage} />
          )}
        </a>
      )}
    </div>
  );
};

class DownloadTag extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileURL: null,
    };
    // console.log("props >>>>", props);
  }

  sendImageData = () => {
    const { props, state } = this;
    console.log("props >>>>", props);
    const fileData = JSON.parse(props.fileDetails);
    console.log("fileData", fileData.file_id);

    myDataProvider(CREATE, "/proof_of_payment/download_file", {
      data: { file_id: fileData.file_id },
    })
      .then((json) => {
        if (json.data.status === "success") {
          window.open(json.data.file_url, "_blank");
        }
      })
      .catch((error) => console.log("error", error));
  };
  render() {
    return (
      <div className="download-button" onClick={this.sendImageData}>
        download
      </div>
    );
  }
}

const StatusField = ({ source }) => {
  const record = useRecordContext();
  return (
    <span>{record[source] === null ? "-" : record[source] ? "Yes" : "No"}</span>
  );
};

const selectInputStyle = {
  width: 200,
};

const PostFilter = (props) => {
  const proofOfPaymentForm = getLocalStorageKey("proof_of_payment_form");
  const showOrderNumber =
    proofOfPaymentForm && proofOfPaymentForm.order_number.show;
  const showModeOfPayment =
    proofOfPaymentForm && proofOfPaymentForm.mode_of_payment.show;
  const modeOfPaymentChoice =
    showModeOfPayment &&
    Object.keys(proofOfPaymentForm.mode_of_payment.values).map((item) => {
      return { id: item, name: item };
    });
  console.log("modeOfPaymentChoice", modeOfPaymentChoice);
  return (
    <Filter {...props}>
      <DateInput source="created_at" label="Uploaded date from" />
      <DateInput source="updated_at" label="Uploaded date to" />
      <ReferenceInput
        label="Sold To Name"
        source="business_id"
        reference="businesses"
        linkType="show"
        allowEmpty
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      {showOrderNumber && (
        <ReferenceInput
          label="Order Number"
          source="sap_digital_order_id"
          reference="sap_digital_orders"
          linkType="show"
          allowEmpty
        >
          <AutocompleteInput optionText="order_number" />
        </ReferenceInput>
      )}

      {showModeOfPayment && (
        <SelectInput
          style={selectInputStyle}
          source="mode_of_payment"
          label="Mode Of Payment"
          choices={modeOfPaymentChoice}
          validate={required()}
        />
      )}

      <SelectInput
        style={selectInputStyle}
        source="approved"
        label="Account Credited"
        choices={[
          { id: true, name: "Yes" },
          { id: false, name: "No" },
        ]}
        validate={required()}
      />
    </Filter>
  );
};

const styles = {
  image: {
    height: 50,
    width: 50,
  },
};
const CreateDownloadButton = () => {
  const record = useRecordContext();
  return (
    <Button>
      <div>
        <DownloadTag fileDetails={record.file_url_data}></DownloadTag>
        {/* <a className="download-button" href={record.file_url} target = '_blank'>Download</a> */}
      </div>
    </Button>
  );
};

const ImageShow = () => {
  const record = useRecordContext();
  console.log("record", record);

  return (
    <div>
      <PostPanel imageDetails={record.file_url_data}></PostPanel>
    </div>
  );
};

const EditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

export const PostList = (props) => {
  const proofOfPaymentForm = getLocalStorageKey("proof_of_payment_form");
  const showOrderNumber =
    proofOfPaymentForm && proofOfPaymentForm.order_number.show;
  const showModeOfPayment =
    proofOfPaymentForm && proofOfPaymentForm.mode_of_payment.show;

  return (
    <Scrollbars className="scroll-container">
      <List
        {...props}
        filters={<PostFilter />}
        sort={{ field: "created_at", order: "DESC" }}
        title="Proof Of Payment"
        exporter={false}
      >
        <Datagrid bulkActionButtons={false}>
          <DateField
            source="created_at"
            label="Upload Timestamp"
            showTime
            options={{
              year: "numeric",
              hourCycle: "h12",
              month: "numeric",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
            }}
          />
          <ReferenceField
            label="Sold To Id "
            source="business_id"
            reference="businesses"
            link="show"
            allowEmpty
          >
            <TextField source="sap_code" />
          </ReferenceField>
          {showOrderNumber && (
            <ReferenceField
              label="Order Number "
              source="sap_digital_order_id"
              reference="sap_digital_orders"
              link="show"
              allowEmpty
            >
              <TextField source="order_number" />
            </ReferenceField>
          )}
          {showModeOfPayment && <TextField source="mode_of_payment" />}
          <ReferenceField
            label="Sold To Name"
            source="business_id"
            reference="businesses"
            link="show"
            allowEmpty
          >
            <TextField source="name" />
          </ReferenceField>
          <StatusField source="approved" label="Account Credited" />
          <EditButton label="Edit" />
          <ImageShow
            source="file_url_data."
            label="Proof Of Payment"
            className={styles.image}
          />
          <CreateDownloadButton label="Download" />
        </Datagrid>
      </List>
    </Scrollbars>
  );
};

export const PostEdit = ({ permissions, ...props }) => (
  <Edit {...props} undoable={false}>
    <SimpleForm toolbar={<EditToolbar />}>
      {/* <DateInput source="created_at" label="Upload Timestamp" showTime /> */}
      <SelectInput
        selected="name"
        source="approved"
        label="Account Credited"
        choices={[
          { id: true, name: "Yes" },
          { id: false, name: "No" },
        ]}
        defaultValue="approved"
      />
    </SimpleForm>
  </Edit>
);
